import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useChatbot } from '../../context/ChatbotContext';
import OnboardingInterview from '../../components/onboarding/OnboardingInterview';

const ChatbotInterviewPage: React.FC = () => {
  const { account } = useChatbot();
  const navigate = useNavigate();
  const channelId = account?.platform_id || '';

  return (
    <div className="-m-6 h-[calc(100%+48px)]">
      <OnboardingInterview
        channelId={channelId}
        onComplete={() => navigate('../knowledge-base', { replace: true })}
      />
    </div>
  );
};

export default ChatbotInterviewPage;
